import * as Yup from 'yup';

export default Yup.object().shape({
  justification: Yup.string().required('Não pode estar vazio'),
});
